var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPotentialSellerPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#eff9e7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5c-.38 0-.76.12-1.08.37l-4.54 3.55A2.56 2.56 0 0 0 11.4 15.5v5.96c0 .6.49 1.09 1.09 1.09h11.02c.6 0 1.09-.49 1.09-1.09V15.5c0-.82-.36-1.59-.98-2.08l-.05-.04V11.3a.47.47 0 0 0-.47-.47h-1.56a.47.47 0 0 0-.47.47v.5L19.08 9.87A1.64 1.64 0 0 0 18 9.5zm0 .93c.15 0 .3.05.44.15l1.93 1.52a.47.47 0 0 0 .79-.35v-1h.62v2.22a.47.47 0 0 0 .18.37l.22.18c.33.26.54.67.54 1.12v5.96a.15.15 0 0 1-.16.16H12.49a.15.15 0 0 1-.16-.16V15.5c0-.45.2-.86.54-1.1l3.55-2.79c.17-.13.38-.18.58-.18zM15.09 15.8a.47.47 0 0 0-.47.47v2.5c0 .26.21.47.47.47h1.87c.26 0 .47-.21.47-.47v-2.5a.47.47 0 0 0-.47-.47h-1.87zm4.06 0a.47.47 0 0 0-.47.47v2.5c0 .26.21.47.47.47h1.87c.26 0 .47-.21.47-.47v-2.5a.47.47 0 0 0-.47-.47h-1.87zM15.56 16.73h.93v1.56h-.93v-1.56zm4.05 0h.94v1.56h-.94v-1.56z",
    fill: "#3A9111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotentialSellerPlaceholder);
export default __webpack_public_path__ + "static/media/potential-seller-placeholder.c28f5eb77d74e1bb245a7f800092a286.svg";
export { ForwardRef as ReactComponent };